export default __webpack_public_path__ + "static/oeko-tex-madeingreen-79e1d3505c7c5691f8a35b95dade67c9.png";